export const mapCandidateDetails = (response, masterData) => {
  // Handle Pre-Onboarding API response
  const data =
    response?.candidateParentModel ||
    response?.data?.candidateParentModel ||
    response ||
    {};

  const profile = data?.basicDetails?.candidateProfile || {};

  const personalDetails = response?.personalDetails || {};

  const addressDetails = response?.address || {};

  const domicileDetails = response?.domicileDetails || {};

  const address = data?.addressDetails || {};

  const documents = data?.documentDetails || [];

  const disability = data?.basicDetails?.disabilityDetails?.[0] || {};

  // Master Maps
  const genderMap = Object.fromEntries(
    (masterData?.genderMasters || []).map((item) => [
      item.genderId,
      item.gender,
    ]),
  );

  const maritalStatusMap = Object.fromEntries(
    (masterData?.maritalStatusMaster || []).map((item) => [
      item.maritalStatusId,
      item.maritalStatus,
    ]),
  );

  const religionMap = Object.fromEntries(
    (masterData?.religionMaster || []).map((item) => [
      item.religionId,
      item.religion,
    ]),
  );

  const countryMap = Object.fromEntries(
    (masterData?.countries || []).map((item) => [
      item.countryId,
      item.countryName,
    ]),
  );

  const stateMap = Object.fromEntries(
    (masterData?.states || []).map((item) => [item.stateId, item.stateName]),
  );

  const districtMap = Object.fromEntries(
    (masterData?.districts || []).map((item) => [
      item.districtId,
      item.districtName,
    ]),
  );

  const disabilityMap = Object.fromEntries(
    (masterData?.disabilityCategories || []).map((item) => [
      item.disabilityCategoryId,
      item.disabilityName,
    ]),
  );

  const casteCategoryMap = Object.fromEntries(
    (masterData?.reservationCategories || []).map((item) => [
      item.reservationCategoriesId,
      item.categoryName,
    ]),
  );

  // const panDocument = documents.find((doc) => doc.displayName === "Pan Card");

  // const passportDocument = documents.find(
  //   (doc) => doc.displayName === "Passport",
  // );

  // const drivingLicenceDocument = documents.find(
  //   (doc) => doc.displayName === "Driving Licence",
  // );

  const disabilityCertificateDocument = documents.find(
    (doc) => doc.displayName === "DISABILITY",
  );

  const candidateDocuments = data?.documentDetails || [];
  const preOnboardingDocuments = response?.documents || [];

  const candidatePanDocument = candidateDocuments.find(
    (doc) => doc.displayName === "Pan Card",
  );

  const prePanDocument = preOnboardingDocuments.find(
    (doc) => doc.documentType === "PAN_CARD",
  );

  // Candidate Profile has higher priority
  const panDocument = candidatePanDocument || prePanDocument;
  console.log(candidateDocuments);

  // Address Proof (Pre-Onboarding only)
  const addressProofDocument = preOnboardingDocuments.find(
    (doc) => doc.documentType === "ADDRESS_PROOF",
  );

  // Voter ID
  const voterIdDocument =
    preOnboardingDocuments.find((doc) => doc.documentType === "VOTER_ID") ||
    candidateDocuments.find((doc) => doc.displayName === "Voter ID");

  // Driving Licence
  const candidateDrivingDocument = candidateDocuments.find(
    (doc) => doc.displayName === "Driving Licence",
  );

  const preDrivingDocument = preOnboardingDocuments.find(
    (doc) => doc.documentType === "DRIVING_LICENSE",
  );

  // Candidate Profile has priority
  const drivingLicenceDocument = candidateDrivingDocument || preDrivingDocument;

  // Passport
  const candidatePassportDocument = candidateDocuments.find(
    (doc) => doc.displayName === "Passport",
  );

  const prePassportDocument = preOnboardingDocuments.find(
    (doc) => doc.documentType === "PASSPORT",
  );

  // Candidate Profile has priority
  const passportDocument = candidatePassportDocument || prePassportDocument;

  return {
    // Personal Details
    gender: genderMap[profile.genderId] || "",
    fullNameSSC: profile.fullNameSSC || "",
    dob: profile.dateOfBirth || "",
    maritalStatus: maritalStatusMap[profile.maritalStatusId] || "",

    mobile: profile.contactNo || "",
    email: profile.email || "",

    casteCommunity: profile.community || "",

    nationality: countryMap[profile.nationality] || "",

    religion: religionMap[profile.religionId] || "",

    casteCategory: casteCategoryMap[profile.reservationCategoryId] || "",

    cibilScore:
      personalDetails.cibilScore?.toString() ||
      profile.cibilScore?.toString() ||
      "",

    cibilScoreDate: personalDetails.cibilScoreDate?.toString() || "",

    fatherName: profile.fatherName || "",

    motherName: profile.motherName || "",

    spouseName: profile.spouseName || "",

    minority: profile.minority ? "Yes" : "No",

    // Documents
    // panNo: panDocument?.documentNumber || "",
    panNo: domicileDetails?.panNo || candidatePanDocument?.documentNumber || "",

    panFileUrl: panDocument?.fileUrl || panDocument?.documentUrl || "",

    panFileName: panDocument?.fileName || panDocument?.documentName || "",

    panDocumentId: panDocument?.id || null,

    panCanDelete: !!prePanDocument && !candidatePanDocument,

    voterIdFileUrl:
      voterIdDocument?.documentUrl || voterIdDocument?.fileUrl || "",

    voterIdFileName:
      voterIdDocument?.documentName || voterIdDocument?.fileName || "",

    voterIdDocumentId: voterIdDocument?.id || null,

    // drivingLicenceNo: drivingLicenceDocument?.documentNumber || "",
    drivingLicenceNo:
      domicileDetails?.drivingLicenseNo ||
      candidateDrivingDocument?.documentNumber ||
      "",

    drivingLicenceFileUrl:
      drivingLicenceDocument?.fileUrl ||
      drivingLicenceDocument?.documentUrl ||
      "",

    drivingLicenceFileName:
      drivingLicenceDocument?.fileName ||
      drivingLicenceDocument?.documentName ||
      "",

    drivingLicenceDocumentId: drivingLicenceDocument?.id || null,

    drivingLicenceCanDelete: !!preDrivingDocument && !candidateDrivingDocument,

    passportNo:
      domicileDetails?.passportNo ||
      candidatePassportDocument?.documentNumber ||
      "",

    passportFileUrl:
      passportDocument?.fileUrl || passportDocument?.documentUrl || "",

    passportFileName:
      passportDocument?.fileName || passportDocument?.documentName || "",

    passportDocumentId: passportDocument?.id || null,

    passportCanDelete: !!prePassportDocument && !candidatePassportDocument,

    addressProofDocumentId: addressProofDocument?.id || null,
    // Disability
    personWithDisability: profile.disability ? "Yes" : "No",

    disabilities:
      data?.basicDetails?.disabilityDetails?.map((item) => ({
        disabilityCategoryId: item.disabilityCategoryId,
        disabilityPercentage: item.disabilityPercentage,
        natureOfDisability: disabilityMap[item.disabilityCategoryId] || "",
      })) || [],

    disabilityBoardName: personalDetails?.disabilityCertificateBoardName || "",

    disabilityReferenceNumber:
      personalDetails?.disabilityCertificateReferenceNo || "",

    disabilityCertificateDate:
      personalDetails?.disabilityCertificateIssueDate || "",

    disabilityFile: disabilityCertificateDocument?.fileUrl || "",
    disabilityName: disabilityCertificateDocument?.fileName || "",

    // Correspondence Address
    corrAddressLine1:
      addressDetails.correspondenceAddressLine1?.toString() ||
      address.addressLine1?.toString() ||
      "",

    corrAddressLine2:
      addressDetails.correspondenceAddressLine2?.toString() ||
      address.addressLine2?.toString() ||
      "",

    corrAddressLine3:
      addressDetails.correspondenceAddressLine3?.toString() || "",

    // IDs
    corrStateId:
      addressDetails?.correspondenceStateId ?? address?.stateId ?? "",

    corrDistrictId:
      addressDetails?.correspondenceDistrictId ?? address?.districtId ?? "",

    corrState:
      stateMap[addressDetails?.correspondenceStateId || address?.stateId] || "",

    corrDistrict:
      districtMap[
      addressDetails?.correspondenceDistrictId || address?.districtId
      ] || "",

    corrCity: addressDetails?.correspondenceCityName || address?.city || "",
    corrCityId: addressDetails?.correspondenceCityId ?? "",

    corrPincode:
      addressDetails?.correspondencePincode || address?.pincode || "",

    // Permanent Address
    // Permanent Address
    permanentAddressLine1:
      addressDetails?.permanentAddressLine1?.toString() ||
      address?.permanentAddressLine1?.toString() ||
      "",

    permanentAddressLine2:
      addressDetails?.permanentAddressLine2?.toString() ||
      address?.permanentAddressLine2?.toString() ||
      "",

    permanentAddressLine3:
      addressDetails?.permanentAddressLine3?.toString() ||
      address?.permanentAddressLine3?.toString() ||
      "",

    // IDs
    permStateId:
      addressDetails?.permanentStateId ?? address?.permanentStateId ?? "",

    permDistrictId:
      addressDetails?.permanentDistrictId ?? address?.permanentDistrictId ?? "",

    permCityId: addressDetails?.permanentCityId ?? "",

    // Names
    permState:
      stateMap[addressDetails?.permanentStateId || address?.permanentStateId] ||
      "",

    permDistrict:
      districtMap[
      addressDetails?.permanentDistrictId || address?.permanentDistrictId
      ] || "",

    permCity: addressDetails?.permanentCityName || address?.permanentCity || "",

    permanentPincode:
      addressDetails?.permanentPincode || address?.permanentPincode || "",
    addressProofFileUrl: addressProofDocument?.documentUrl || "",

    // Domicile
    stateOfOrigin: stateMap[address?.permanentStateId] || "",

    stateOfDomicile: stateMap[address?.permanentStateId] || "",

    domicileDistrict: districtMap[address?.permanentDistrictId] || "",

    domicileCity: address?.permanentCity || "",

    bloodGroup: domicileDetails?.bloodGroup || "",

    voterId: domicileDetails?.voterIdCardNo || "",

    drivingLicenseNo:
      domicileDetails?.drivingLicenseNo ||
      drivingLicenceDocument?.documentNumber ||
      "",

    // Experience
    experienceDetails:
      data?.experienceDetails?.map((item) => ({
        workExperienceId: item?.workExperience?.workExperienceId || "",

        panCardNumber: "",
        empCode: "",

        organisationName: item?.workExperience?.organizationName || "",

        organisationAddress: "",

        designation: item?.workExperience?.role || "",

        descriptionOfWork: item?.workExperience?.workDescription || "",

        isPresentlyWorking: item?.workExperience?.isPresentlyWorking || false,

        lastDrawnSalary: item?.workExperience?.currentCtc || "",

        fromDate: item?.workExperience?.fromDate || "",

        toDate: item?.workExperience?.toDate || "",

        reasonForLeaving: "",

        employerEmail: "",
        employerContact: "",

        experienceCertificateUrl: item?.documentStore?.fileUrl || "",

        experienceCertificateName: item?.documentStore?.displayName || "",
      })) || [],

    attestationDetails:
      response?.residentialHistory?.map((item) => ({
        id: item.id || "",
        preOnboardingId: item.preOnboardingId || "",
        attestationFromDate: item.fromDate || "",
        attestationToDate: item.toDate || "",
        addressLine1: item.addressLine1 || "",
        addressLine2: item.addressLine2 || "",
        addressLine3: item.addressLine3 || "",
        cityId: item.cityId || null,
        districtId: item.districtId || null,
        stateId: item.stateId || null,
        pinCode: item.pincode || "",
        preOnboardingDocumentId: item.preOnboardingDocumentId || null,
      })) || [],
  };
};

export const mapPreviousEmploymentDetails = (response, masterData) => {
  const states = masterData?.states || [];
  const districts = masterData?.districts || [];
  const cities = masterData?.cities || [];

  const candidateExperience =
    response?.candidateParentModel?.experienceDetails?.map((item) => ({

      workExperienceId: item?.workExperience?.workExperienceId || "",

      preOnboardingId: null,

      pranCardNumber: "",
      empCode: "",

      organisationName: item?.workExperience?.organizationName || "",

      organisationAddress: "",

      designation: item?.workExperience?.role || "",

      descriptionOfWork: item?.workExperience?.workDescription || "",

      lastDrawnSalary: item?.workExperience?.currentCtc || "",

      fromDate: item?.workExperience?.fromDate || "",

      toDate: item?.workExperience?.toDate || "",

      reasonForLeaving: "",

      employerEmail: "",

      employerContact: "",

      isCurrentlyWorking: item?.workExperience?.isPresentlyWorking || false,
      isEditable: item?.workExperience?.isPresentlyWorking || false,

      experienceCertificateUrl: item?.documentStore?.fileUrl || "",

      experienceCertificateName: item?.documentStore?.displayName || "",
      isCandidateRemove: item.isCandidateRemoval ?? false,
      isNew: false,
    })) || [];

  const preOnboardingExperience =
    response?.previousOrganisations?.length > 0
      ? response.previousOrganisations.map((item, index) => {
        console.log("Previous Org", response.previousOrganisations);

        const candidateDocument =
          response?.candidateParentModel?.experienceDetails?.[index]
            ?.documentStore;

        const uploadedDoc = response?.documents?.find(
          (doc) =>
            doc.referenceTable === "pre_onboarding_previous_organisations" &&
            doc.referenceId === item.id &&
            doc.documentType === "EXPERIENCE_CERTIFICATE",
        );

        return {
          workExperienceId: item.id || "",
          id: item.id || "",

          preOnboardingId: item.preOnboardingId || "",

          pranCardNumber: item.pranCardNumber || "",
          empCode: item.employeeCode || "",

          organisationName: item.organisationName || "",
          organisationAddress: item.organisationAddress || "",

          designation: item.designation || "",
          descriptionOfWork: item.workDescription || "",

          lastDrawnSalary: item.lastDrawnSalary || "",

          fromDate: item.fromDate || "",
          toDate: item.toDate || "",

          reasonForLeaving: item.reasonForLeaving || "",

          employerEmail: item.employerEmail || "",
          employerContact: item.employerContactNo || "",

          isCurrentlyWorking: item.isCurrentlyWorking,
          isEditable: item.isCurrentlyWorking,

          // preOnboardingDocumentId:
          //   item.preOnboardingPrevOrgDocumentId ||
          //   item.preOnboardingDocumentId ||
          //   null,

          // experienceCertificateUrl:
          //   preOnboardingDocument?.documentUrl ||
          //   candidateDocument?.fileUrl ||
          //   "",

          // experienceCertificateName:
          //   preOnboardingDocument?.documentName ||
          //   candidateDocument?.displayName ||
          //   "",
          experienceCertificateUrl:
            uploadedDoc?.documentUrl || candidateDocument?.fileUrl || "",

          experienceCertificateName:
            uploadedDoc?.documentName || candidateDocument?.displayName || "",

          preOnboardingDocumentId: uploadedDoc?.id || null,

          isNew: false,
          isCandidateRemove: item.isCandidateRemoval ?? false,

        };
      })
      : response?.candidateParentModel?.experienceDetails?.map((item) => ({
        workExperienceId: item?.workExperience?.workExperienceId || "",

        preOnboardingId: null,

        pranCardNumber: "",
        empCode: "",

        organisationName: item?.workExperience?.organizationName || "",

        organisationAddress: "",

        designation: item?.workExperience?.role || "",

        descriptionOfWork: item?.workExperience?.workDescription || "",

        lastDrawnSalary: item?.workExperience?.currentCtc || "",

        fromDate: item?.workExperience?.fromDate || "",

        toDate: item?.workExperience?.toDate || "",

        reasonForLeaving: "",

        employerEmail: "",

        employerContact: "",

        isCurrentlyWorking: item?.workExperience?.isPresentlyWorking || false,

        experienceCertificateUrl: item?.documentStore?.fileUrl || "",

        experienceCertificateName: item?.documentStore?.displayName || "",
      })) || [];

  const attestationDetails =
    response?.residentialHistory?.length > 0
      ? response.residentialHistory.map((item) => {
        const document = response?.documents?.find(
          (doc) => doc.id === item.preOnboardingDocumentId,
        );

        return {
          id: item.id || "",
          preOnboardingId: item.preOnboardingId || "",

          attestationFromDate: item.fromDate || "",
          attestationToDate: item.toDate || "",

          addressLine1: item.addressLine1 || "",
          addressLine2: item.addressLine2 || "",
          addressLine3: item.addressLine3 || "",

          cityId: item.cityId || null,
          cityName: item.cityName || null,
          districtId: item.districtId || null,
          stateId: item.stateId || null,

          pinCode: item.pincode || "",

          preOnboardingDocumentId: item.preOnboardingDocumentId || null,

          documentName: document?.documentName || "",

          documentUrl: document?.documentUrl || "",

          state:
            states.find((s) => s.stateId === item.stateId)?.stateName || "",

          district:
            districts.find((d) => d.districtId === item.districtId)
              ?.districtName || "",

          city: cities.find((c) => c.cityId === item.cityId)?.cityName || "",
        };
      })
      : [
        {
          id: "",
          preOnboardingId: "",

          attestationFromDate: "",
          attestationToDate: "",

          addressLine1:
            response?.candidateParentModel?.addressDetails?.addressLine1 ||
            "",

          addressLine2:
            response?.candidateParentModel?.addressDetails?.addressLine2 ||
            "",

          addressLine3: "",

          stateId:
            response?.candidateParentModel?.addressDetails?.stateId || null,

          districtId:
            response?.candidateParentModel?.addressDetails?.districtId ||
            null,

          cityId: null,

          pinCode:
            response?.candidateParentModel?.addressDetails?.pincode || "",

          preOnboardingDocumentId: null,

          documentName: "",
          documentUrl: "",

          state: "",
          district: "",
          city: "",
        },
      ];

  return {
    experienceDetails:
      // response?.previousOrganisations?.map(
      //     (item, index) => ({
      //         workExperienceId: item.id || "",
      //         preOnboardingId:
      //             item.preOnboardingId || "",
      //         pranCardNumber:
      //             item.pranCardNumber || "",
      //         empCode:
      //             item.employeeCode || "",
      //         organisationName:
      //             item.organisationName || "",
      //         organisationAddress:
      //             item.organisationAddress || "",
      //         designation:
      //             item.designation || "",
      //         descriptionOfWork:
      //             item.workDescription || "",
      //         lastDrawnSalary:
      //             item.lastDrawnSalary || "",
      //         fromDate:
      //             item.fromDate || "",
      //         toDate:
      //             item.toDate || "",
      //         reasonForLeaving:
      //             item.reasonForLeaving || "",
      //         employerEmail:
      //             item.employerEmail || "",
      //         employerContact:
      //             item.employerContactNo || "",
      //             isCurrentlyWorking: item.isCurrentlyWorking,

      //         //My change
      //         experienceCertificateUrl:
      //             response?.candidateParentModel
      //                 ?.experienceDetails?.[index]
      //                 ?.documentStore?.fileUrl || "",

      //         experienceCertificateName:
      //             response?.candidateParentModel
      //                 ?.experienceDetails?.[index]
      //                 ?.documentStore?.displayName || "",
      //     })
      // ) || [],

      preOnboardingExperience,

    attestationDetails,

    // attestationDetails:
    //     response?.residentialHistory?.map(
    //         (item) => {

    //             const document =
    //                 response?.documents?.find(
    //                     (doc) =>
    //                         doc.id ===
    //                         item.preOnboardingDocumentId
    //                 );

    //             return {
    //                 id: item.id || "",
    //                 preOnboardingId:
    //                     item.preOnboardingId || "",

    //                 attestationFromDate:
    //                     item.fromDate || "",
    //                 attestationToDate:
    //                     item.toDate || "",

    //                 addressLine1:
    //                     item.addressLine1 || "",
    //                 addressLine2:
    //                     item.addressLine2 || "",
    //                 addressLine3:
    //                     item.addressLine3 || "",

    //                 cityId:
    //                     item.cityId || null,
    //                 districtId:
    //                     item.districtId || null,
    //                 stateId:
    //                     item.stateId || null,

    //                 pinCode:
    //                     item.pincode || "",

    //                 preOnboardingDocumentId:
    //                     item.preOnboardingDocumentId ||
    //                     null,

    //                 documentName:
    //                     document?.documentName || "",

    //                 documentUrl:
    //                     document?.documentUrl || "",

    //                 state:
    //                     states.find(
    //                         (s) =>
    //                             s.stateId === item.stateId
    //                     )?.stateName || "",

    //                 district:
    //                     districts.find(
    //                         (d) =>
    //                             d.districtId ===
    //                             item.districtId
    //                     )?.districtName || "",

    //                 city:
    //                     cities.find(
    //                         (c) =>
    //                             c.cityId === item.cityId
    //                     )?.cityName || "",
    //             };
    //         }
    //     ) || [],

    // attestationDetails:
    //     response?.residentialHistory?.map(
    //         (item) => ({
    //             id: item.id || "",
    //             preOnboardingId:
    //                 item.preOnboardingId || "",
    //             attestationFromDate:
    //                 item.fromDate || "",
    //             attestationToDate:
    //                 item.toDate || "",
    //             addressLine1:
    //                 item.addressLine1 || "",
    //             addressLine2:
    //                 item.addressLine2 || "",
    //             addressLine3:
    //                 item.addressLine3 || "",
    //             cityId:
    //                 item.cityId || null,
    //             districtId:
    //                 item.districtId || null,
    //             stateId:
    //                 item.stateId || null,
    //             pinCode:
    //                 item.pincode || "",
    //             preOnboardingDocumentId:
    //                 item.preOnboardingDocumentId ||
    //                 null,

    //                  state:
    //                 states.find(
    //                     (s) =>
    //                         s.stateId === item.stateId
    //                 )?.stateName || "",

    //             district:
    //                 districts.find(
    //                     (d) =>
    //                         d.districtId === item.districtId
    //                 )?.districtName || "",

    //             city:
    //                 cities.find(
    //                     (c) =>
    //                         c.cityId === item.cityId
    //                 )?.cityName || "",
    //         })
    //     ) || [],
  };
};

export const mapQualificationDetails = (response, masterData) => {
  const data =
    response?.candidateParentModel ||
    response?.data?.candidateParentModel ||
    {};

  const mandatoryQualifications = masterData?.mandatoryQualification || [];

  const specializations = masterData?.specializationMaster || [];

  const educationTypes = masterData?.educationTypeMaster || [];

  const documentTypes = masterData?.documentTypes || [];

  const data1 =
    response?.preOnboardingFamilyDetails ||
    response?.data?.preOnboardingFamilyDetails ||
    {};
  const data2 =
    response?.preOnboardingGratuityNomination ||
    response?.data?.preOnboardingGratuityNomination ||
    {};

  const data3 = response?.preOnboardingQualifications || {};

  const data4 = response?.preOnboardingCertifications || [];

  const documents =
    response?.preOnboardingDocuments ||
    response?.data?.preOnboardingDocuments ||
    [];

  return {
    qualificationDetails:
      data?.educationDetails?.map((item) => {

        const qualification =
          mandatoryQualifications.find(
            (q) =>
              q.educationQualificationsId ===
              item?.education?.educationQualificationsId
          );

        const specialization = specializations.find(
          (s) => s.specializationId === item?.education?.specializationId,
        );

        const educationType = educationTypes.find(
          (e) => e.educationTypeId === item?.education?.educationTypeId,
        );

        const preOnboardingQualification = data3.find(
          (q) => q.educationId === item?.education?.educationId,
        );

        // Existing course qualification
        // Existing course qualification
        const qualificationForLevel =
          mandatoryQualifications.find(
            (q) =>
              q.educationQualificationsId ===
              (
                preOnboardingQualification?.qualificationName ||
                item?.education?.educationQualificationsId
              )
          );

        // Get Graduation / Post Graduation / SSC etc.
        const qualificationLevel =
          documentTypes.find(
            (d) =>
              d.documentTypeId === qualificationForLevel?.levelId
          );


        console.log("qualificationForLevel", qualificationForLevel);
        console.log("levelId", qualificationForLevel?.levelId);
        console.log("qualificationLevel", qualificationLevel);

        console.log("documentTypes", masterData?.documentTypes);
        return {
          educationId:
            item?.education?.educationId || "",

          // Course
          courseId: item?.education?.educationQualificationsId || "",

          courseName: qualification?.qualificationName || "",


          qualificationLevel:
            qualificationLevel?.documentName || "",

          // Specialization
          specializationId:
            item?.education?.specializationId || "",

          specializationName: specialization?.specializationName || "",

          // Institution
          schoolInstitution: item?.education?.institutionName || "",

          // University
          universityName: item?.education?.universityName || "",

          // Percentage
          percentageMarks: item?.education?.percentage || "",

          // Passing Date
          dateOfPassing: item?.education?.endDate || "",

          // Division
          division: preOnboardingQualification?.division || "",

          // Nature Of Course
          educationTypeId: item?.education?.educationTypeId || "",

          natureOfCourse: educationType?.educationType || "",

          uploadDocument: {
            id: item?.documentStore?.id || "",

            name: item?.documentStore?.displayName || "",

            fileUrl: item?.documentStore?.fileUrl || "",
          },
        };
      }) || [],

    candidateCertifications: [
      ...(data?.candidateCertifications || []).map((item) => {
        const pre = data4.find(
          (q) =>
            q.candidateCertificateId ===
            item?.certifications?.certificateId
        );


        const document = documents.find(


          (doc) =>
            String(doc.id) ===
            String(pre?.preOnboardingCandDocId)
        );

        console.log("====================================");
        console.log("Current Item");
        console.log(item);

        console.log("item.certificationId", item.certificationId);
        console.log("item.certificationName", item.certificationName);
        console.log("item.otherCertificationName", item.otherCertificationName);

        const masterCertificate = masterData?.certificationMaster?.find(
          (c) =>
            String(c.certificationMasterId) ===
            String(pre?.certificationId || item?.certifications?.certificationId)
        );

        const isOther =
          masterCertificate?.certificationName === "Other";

        const otherCertificationName =
          pre?.otherCertificationName ||
          pre?.certificationName ||
          item?.certifications?.otherCertificationName ||
          item?.certifications?.certificationName ||
          "";

        return {
          certificationMasterId:
            pre?.certificationId ||
            item?.certifications?.certificationId ||
            "",

          candidateCertificateId:
            item?.certifications?.certificateId || null,

          certificationName: isOther
            ? "Other"
            : (
              masterCertificate?.certificationName ||
              item?.certifications?.certificationName ||
              ""
            ),

          otherCertificationName: isOther
            ? otherCertificationName
            : "",

          institutionName:
            pre?.institutionName ||
            item?.certifications?.issuedBy ||
            "",

          certificationDateOfPassing:
            pre?.passingDate ||
            item?.certifications?.certificationDate ||
            "",

          certificationPercentage:
            pre?.percentage ||
            item?.certifications?.percentage ||
            "",

          preOnboardingId:
            pre?.preOnboardingId || null,

          id:
            pre?.id || null,

          preOnboardingCandDocId:
            pre?.preOnboardingCandDocId || null,

          displayName:
            document?.documentName ||
            item?.documentStore?.fileName ||
            item?.documentStore?.displayName ||
            "",

          fileUrl:
            document?.documentUrl ||
            item?.documentStore?.fileUrl ||
            "",
        };
      }),

      ...data4
        .filter((item) => !item.candidateCertificateId)
        .map((item) => {

          const document = documents.find(
            (doc) =>
              String(doc.id) === String(item.preOnboardingCandDocId) ||
              String(doc.documentIdentifier) ===
              String(item.preOnboardingCandDocId)
          );

          const masterCertificates = masterData?.certificationMaster || [];

          // Try master lookup first
          const masterCertificate = masterCertificates.find(
            (c) =>
              String(c.certificationMasterId) ===
              String(item.certificationId)
          );

          // Fallback: detect "Other" using the UUID returned by backend
          const isOther =
            masterCertificate?.certificationName === "Other" ||
            String(item.certificationId) ===
            "2b21484c-9b31-4864-9707-3e12c93356d2";

          console.log("========== CERTIFICATE DEBUG ==========");
          console.log("Master Certificates:", masterCertificates);
          console.log("Current API Item:", item);
          console.log("Matched Master:", masterCertificate);
          console.log("Is Other:", isOther);

          const dropdownName = isOther
            ? "Other"
            : (
              masterCertificate?.certificationName ||
              item.certificationName ||
              ""
            );

          const otherName = isOther
            ? (item.certificationName || "")
            : "";

          console.log("Mapped Certificate =>", {
            certificationMasterId: item.certificationId,
            dropdownName,
            otherName,
            institutionName: item.institutionName,
            passingDate: item.passingDate,
          });

          return {
            certificationMasterId: item.certificationId || "",

            candidateCertificateId: item.candidateCertificateId || null,

            // Dropdown value
            certificationName: dropdownName,

            // Textbox value
            otherCertificationName: otherName,

            institutionName:
              item.institutionName || "",

            certificationDateOfPassing:
              item.passingDate || "",

            certificationPercentage:
              item.percentage || "",

            preOnboardingId:
              item.preOnboardingId || null,

            id:
              item.id || null,

            preOnboardingCandDocId:
              item.preOnboardingCandDocId || null,

            displayName:
              document?.documentName || "",

            fileUrl:
              document?.documentUrl || "",
          };
        }),
    ],
    // candidateCertifications:
    //     data?.candidateCertifications?.map(
    //         (item) => ({

    //             certificationId:
    //                 item?.certifications?.certificateId || "",

    //             certificationName:
    //                 item?.certifications?.certificationName || "",

    //             institutionName:
    //                 item?.certifications?.issuedBy || "",

    //             certificationDateOfPassing:
    //                 item?.certifications?.certificationDate || "",

    //             certificationPercentage:
    //                 item?.certifications?.percentage || "",

    //             fileId:
    //                 item?.documentStore?.id || "",

    //             displayName:
    //                 item?.documentStore?.fileName || "",

    //             fileUrl:
    //                 item?.documentStore?.fileUrl || "",
    //         })
    //     ) || [],

    preOnboardingFamilyDetails:
      (data1 || []).map((item) => ({
        familyId: item.familyId || item.id,
        familyPreOnboardingId:
          item.familyPreOnboardingId ||
          item.preOnboardingId,

        fullName: item.fullName || "",
        relationship: item.relationship || "",
        dateOfBirth: item.dateOfBirth || "",
        nationality: item.nationality || "",

        dependent:
          item.isDependent ? "Yes" : "No",

        benchmarkDisability:
          item.isPwd ? "Yes" : "No",

        occupation: item.occupation || "",
        annualIncome: item.annualIncome || "",
        mobileNumber: item.mobileNumber || "",
      })),

    preOnboardingGratuityNomination:
      (data2 || []).map((item) => ({
        gratuityId:
          item.gratuityId || item.id,

        gratuityPreOnboardingId:
          item.gratuityPreOnboardingId ||
          item.preOnboardingId,

        nomineeName:
          item.nomineeName || "",

        nomineeRelationship:
          item.nomineeRelationship || "",

        nomineeAge:
          item.nomineeAge || "",

        nomineeAddress:
          item.nomineeAddress || "",

        amountOfShare:
          item.sharePercentage || "",
      })),

  };
};

export const mapOtherDetails = (
  response,
  masterData
) => {
  const data = response;
  const documents = data?.preOnboardingDocuments || [];

  return {


    preOnboardingReferences:
      data?.preOnboardingReferences?.map((item) => {
        const document = documents.find(
          (doc) =>
            String(doc.referenceId) === String(item.id) ||
            String(doc.preOnboardingReferenceId) === String(item.id)
        );

        return {
          id: item?.id || "",
          preOnboardingId: item?.preOnboardingId || "",

          referenceName: item?.referenceName || "",
          referenceDesignation: item?.designation || "",
          referenceOrganisation: item?.organisation || "",
          referenceContact: item?.contactNumber || "",
          referenceEmail: item?.emailId || "",

          referenceDocumentId:
            document?.id || "",

          referenceDocumentName:
            document?.documentName || "",

          referenceDocumentUrl:
            document?.documentUrl || "",

          referenceDocument: null,
          isNew: false,
        };
      }) || [
        {
          id: "",
          preOnboardingId: "",
          referenceName: "",
          referenceDesignation: "",
          referenceOrganisation: "",
          referenceContact: "",
          referenceEmail: "",
        },
        {
          id: "",
          preOnboardingId: "",
          referenceName: "",
          referenceDesignation: "",
          referenceOrganisation: "",
          referenceContact: "",
          referenceEmail: "",
        },
      ],

    preOnboardingOtherDetails: {
      id: data?.preOnboardingOtherDetails?.id || "",

      preOnboardingId: data?.preOnboardingOtherDetails?.preOnboardingId || "",

      markOfIdentification:
        data?.preOnboardingOtherDetails?.identificationMark || "",

      practicalTraining:
        data?.preOnboardingOtherDetails?.practicalTrainingDetails || "",

      publications: data?.preOnboardingOtherDetails?.publicationDetails || "",

      futureCourse: data?.preOnboardingOtherDetails?.furtherCourseDetails || "",

      professionalMembership:
        data?.preOnboardingOtherDetails?.professionalBodyDetails || "",

      legalHistory: data?.preOnboardingOtherDetails?.criminalCaseDetails || "",

      otherInformation:
        data?.preOnboardingOtherDetails?.additionalInformation || "",
    },
  };
};

// export const mapQualificationDetails = (
//     response,
//     masterData
// ) => {
//     const data =
//         response?.candidateParentModel ||
//         response?.data?.candidateParentModel ||
//         {};

//     return {
//         qualificationDetails:
//             data?.educationDetails?.map(
//                 (item) => ({
//                     educationId:
//                         item?.education?.educationId || "",

//                     courseId:
//                         item?.education?.educationQualificationsId || "",
//                     courseName:
//                         item?.education?.educationQualificationsName || "",

//                     specialization: item?.education?.specializationName || "",
//                     specializationId: item?.education?.specializationId || "",

//                     schoolInstitution:
//                         item?.education
//                             ?.institutionName || "",

//                     mainSubject:
//                         item?.education
//                             ?.otherSpecialization || "",

//                     universityName:
//                         item?.education
//                             ?.universityName || "",

//                     percentageMarks:
//                         item?.education
//                             ?.percentage || "",

//                     dateOfPassing:
//                         item?.education
//                             ?.endDate || "",

//                     division:
//                         item?.education
//                             ?.division || "",

//                     natureOfCourse:
//                         item?.education
//                             ?.educationTypeName || "",

//                     uploadDocument: {
//                         id:
//                             item?.documentStore?.id ||
//                             "",

//                         name:
//                             item?.documentStore
//                                 ?.displayName || "",

//                         fileUrl:
//                             item?.documentStore
//                                 ?.fileUrl || "",
//                     },
//                 })
//             ) || [],
//     };
// };
